import { UseFormGetValues } from "react-hook-form";
import { ProfileFormData } from "../profile-components/profile-form-data";

export const useValidateProfileInputs = (getValue: UseFormGetValues<ProfileFormData>) => {
  const validateHasFirstName = (): boolean => {
    const name = getValue("firstName");
    if (!name || name === "") {
      return false;
    } else {
      return true;
    }
  };

  const validateHasLastName = (): boolean => {
    const name = getValue("lastName");
    if (!name || name === "") {
      return false;
    } else {
      return true;
    }
  };

  const validateHasEmail = (): boolean => {
    const email = getValue("email");
    if (!email || email === "") {
      return false;
    } else {
      return true;
    }
  };

  const validateHasValidEmail = (): boolean => {
    const email = getValue("email");
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email ?? "")) {
      return false;
    } else {
      return true;
    }
  };

  const validateEditParameter = () => {
    return validateHasFirstName() && validateHasLastName() && validateHasEmail() && validateHasValidEmail();
  };

  return { validateHasFirstName, validateHasLastName, validateHasEmail, validateHasValidEmail, validateEditParameter };
};
